function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @module ol/renderer/Layer
 */
import EventType from '../events/EventType.js';
import ImageState from '../ImageState.js';
import Observable from '../Observable.js';
import { abstract } from '../util.js';
var maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */

var LayerRenderer = /*#__PURE__*/function (_Observable) {
  _inherits(LayerRenderer, _Observable);

  var _super = _createSuper(LayerRenderer);

  /**
   * @param {LayerType} layer Layer.
   */
  function LayerRenderer(layer) {
    var _this;

    _classCallCheck(this, LayerRenderer);

    _this = _super.call(this);
    /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */

    _this.ready = true;
    /** @private */

    _this.boundHandleImageChange_ = _this.handleImageChange_.bind(_assertThisInitialized(_this));
    /**
     * @private
     * @type {LayerType}
     */

    _this.layer_ = layer;
    /**
     * @type {Array<string>}
     * @private
     */

    _this.staleKeys_ = new Array();
    /**
     * @type {number}
     * @protected
     */

    _this.maxStaleKeys = maxStaleKeys;
    return _this;
  }
  /**
   * @return {Array<string>} Get the list of stale keys.
   */


  _createClass(LayerRenderer, [{
    key: "getStaleKeys",
    value: function getStaleKeys() {
      return this.staleKeys_;
    }
    /**
     * @param {string} key The new stale key.
     */

  }, {
    key: "prependStaleKey",
    value: function prependStaleKey(key) {
      this.staleKeys_.unshift(key);

      if (this.staleKeys_.length > this.maxStaleKeys) {
        this.staleKeys_.length = this.maxStaleKeys;
      }
    }
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
     * an array of features.
     */

  }, {
    key: "getFeatures",
    value: function getFeatures(pixel) {
      return abstract();
    }
    /**
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
     */

  }, {
    key: "getData",
    value: function getData(pixel) {
      return null;
    }
    /**
     * Determine whether render should be called.
     * @abstract
     * @param {import("../Map.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */

  }, {
    key: "prepareFrame",
    value: function prepareFrame(frameState) {
      return abstract();
    }
    /**
     * Render the layer.
     * @abstract
     * @param {import("../Map.js").FrameState} frameState Frame state.
     * @param {HTMLElement|null} target Target that may be used to render content to.
     * @return {HTMLElement|null} The rendered element.
     */

  }, {
    key: "renderFrame",
    value: function renderFrame(frameState, target) {
      return abstract();
    }
    /**
     * @abstract
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../Map.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */

  }, {
    key: "forEachFeatureAtCoordinate",
    value: function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
      return undefined;
    }
    /**
     * @return {LayerType} Layer.
     */

  }, {
    key: "getLayer",
    value: function getLayer() {
      return this.layer_;
    }
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     * @abstract
     */

  }, {
    key: "handleFontsChanged",
    value: function handleFontsChanged() {}
    /**
     * Handle changes in image state.
     * @param {import("../events/Event.js").default} event Image change event.
     * @private
     */

  }, {
    key: "handleImageChange_",
    value: function handleImageChange_(event) {
      var image =
      /** @type {import("../Image.js").default} */
      event.target;

      if (image.getState() === ImageState.LOADED || image.getState() === ImageState.ERROR) {
        this.renderIfReadyAndVisible();
      }
    }
    /**
     * Load the image if not already loaded, and register the image change
     * listener if needed.
     * @param {import("../Image.js").default} image Image.
     * @return {boolean} `true` if the image is already loaded, `false` otherwise.
     * @protected
     */

  }, {
    key: "loadImage",
    value: function loadImage(image) {
      var imageState = image.getState();

      if (imageState != ImageState.LOADED && imageState != ImageState.ERROR) {
        image.addEventListener(EventType.CHANGE, this.boundHandleImageChange_);
      }

      if (imageState == ImageState.IDLE) {
        image.load();
        imageState = image.getState();
      }

      return imageState == ImageState.LOADED;
    }
    /**
     * @protected
     */

  }, {
    key: "renderIfReadyAndVisible",
    value: function renderIfReadyAndVisible() {
      var layer = this.getLayer();

      if (layer && layer.getVisible() && layer.getSourceState() === 'ready') {
        layer.changed();
      }
    }
    /**
     * @param {import("../Map.js").FrameState} frameState Frame state.
     */

  }, {
    key: "renderDeferred",
    value: function renderDeferred(frameState) {}
    /**
     * Clean up.
     * @override
     */

  }, {
    key: "disposeInternal",
    value: function disposeInternal() {
      delete this.layer_;

      _get(_getPrototypeOf(LayerRenderer.prototype), "disposeInternal", this).call(this);
    }
  }]);

  return LayerRenderer;
}(Observable);

export default LayerRenderer;